<template>
    <div class="page page-tight preJobPage">
        <!--<h3 class="page-title">{{$t('course.myCourse')}}</h3>-->

        <el-form class="page-query" ref="ruleCard" :model="formSearch" :inline="true" size="mini">
            <el-form-item :label="$t('c.username')">
                <el-input v-model="formSearch.name" :placeholder="$t('tip.username')" clearable></el-input>
            </el-form-item>
            <el-form-item :label="$t('c.account')">
                <el-input v-model="formSearch.account" :placeholder="$t('tip.account')" clearable></el-input>
            </el-form-item>
            <select-multi-orgs @orgsChange="orgsChange"></select-multi-orgs>
            <select-multiple :nameArrays="selectNames"
                             @getPreJobVal="getPreJobVal">
            </select-multiple>

            <el-form-item label="日期">
                <el-date-picker
                    v-model="formSearch.afterData"
                    type="date"
                    :placeholder="$t('tip.startTime')"
                    :picker-options="pickerOptions1"
                    value-format="yyyy-MM-dd">
                </el-date-picker>
                <span>{{$t('c.to')}}</span>
                <el-date-picker
                    v-model="formSearch.beforeDate"
                    type="date"
                    :placeholder="$t('tip.endTime')"
                    :picker-options="pickerOptions2"
                    value-format="yyyy-MM-dd">
                </el-date-picker>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="query(1)" round>{{$t('c.query')}}</el-button>
            </el-form-item>
        </el-form>
        <div class="page-table">
            <div class="page-operate">
                <div class="button-group">
                    <!-- 证书导入 -->
                    <el-dropdown placement="bottom">
                        <el-button size="small">
                            <span><i class="nucfont inuc-import"></i></span>
                        </el-button>
                        <el-dropdown-menu class="dropdown-menu" slot="dropdown">
                            <el-dropdown-item>
                                <label class="btn" @click="downloadTemplate">
                                    下载开岗放权模板
                                </label>
                            </el-dropdown-item>
                            <el-dropdown-item>
                                <label class="btn" @change="importPreJob($event)">
                                    导入开岗放权
                                    <input type="file" accept=".xls,.xlsx">
                                </label>
                            </el-dropdown-item>
                            <el-dropdown-item>
                                <label class="btn" @click="picDialog = true">
                                    导入证书照片
                                </label>
                            </el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>

                    <el-tooltip class="item" effect="dark" content="导出开岗放权" placement="top-start"
                                :hide-after="1000">
                        <el-button size="small" @click="exportPreJob('ruleCard')">
                            <label class="btn">
                                <i class="nucfont inuc-daochu"></i>
                            </label>
                        </el-button>
                    </el-tooltip>
                </div>
            </div>

            <div class="form-table sc-table">
                <el-table ref="prejobTable"
                          :data="tableData"
                          height="auto"
                          :border="true"
                          :stripe="false"
                          v-if="titles.length"
                >
                    <!-- column title -->
                    <el-table-column fixed property="userName" label="姓名" align="center"
                                     show-overflow-tooltip sortable></el-table-column>
                    <el-table-column fixed :label="$t('c.account')" align="center" property="accountNo" width="110" show-overflow-tooltip
                                     sortable>
                    </el-table-column>
                    <el-table-column fixed label="所属机构" align="center" property="orgName" show-overflow-tooltip
                                     sortable>
                    </el-table-column>

                    <el-table-column v-for="title in titles"
                                     :prop="title.prop"
                                     :label="title.label"
                                     :key="title.label"
                                     align="center"
                                     width="200px">
                        <template #default="{row}">
                            <template v-for="item in row.approvals">
                                <div class="approval-cell" v-if="title.id === item.approvalID">
                                    <img class="photo" v-if="item.photo" :src="`${item.photo}?access_token=${token}`" alt="photo" v-viewer>
                                    <div class="date">
                                        <span>{{item.approveTime | date}}</span>
                                    </div>
                                    <div class="remove-wrap" @click="deleteApproval(row.userID, item.approvalID)" title="删除" v-permission="[1]">
                                        <i class="nucfont inuc-remove-circle"></i>
                                    </div>
                                </div>
                            </template>
                        </template>
                    </el-table-column>

                    <!-- column buttons -->
                    <el-table-column :label="$t('c.operation')" align="center" width="80px" fixed="right">
                        <div class="btn-cell" slot-scope="scope" v-permission="[1]">
                            <i class="nucfont inuc-add-circle" style="cursor: pointer"
                               :title="$t('c.add')"
                               @click="editApproval(scope.row)"></i>
                        </div>
                    </el-table-column>
                </el-table>
            </div>

            <div class="pagination-bar">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                               :current-page="currentPage" :page-sizes="[20, 50, 100, 300, 500]"
                               :page-size="pageSize"
                               layout="prev, pager, next, jumper, sizes,total" :total="pagTotal">
                </el-pagination>
            </div>
        </div>

        <el-dialog title="证书照片导入"
                   width="400px"
                   class="pic-dialog"
                   :visible.sync="picDialog"
                   :close-on-click-modal="false"
                   :append-to-body="true"
                   :modal-append-to-body="true"
        >
            <div class="explain-text">
                <p>1、证书照片导入流程请阅读<a class="sample" :href="zipGuideUrl">《证书照片导入指南》</a>。</p>
                <p>2、点击<a class="sample" :href="zipSampleUrl">下载</a> 压缩包样例文件。</p>
            </div>
            <div slot="footer" class="dialog-footer" style="text-align: center;">
                <el-button type="primary" @click="certUploadByPic">开始上传</el-button>
            </div>
        </el-dialog>

        <el-dialog
            title="开岗放权"
            :visible.sync="approvalDialog"
            custom-class="role-dialog"
            width="450px"
            :modal-append-to-body="false"
            :close-on-click-modal="true">
            <el-form :model="ruleForm" :rules="ruleRules" class="rule-form" ref="ruleForm" label-width="100px">
                <el-form-item label="类型" prop="type" style="margin-top: 15px">
                    <el-select v-model="ruleForm.type" collapse-tags placeholder="请选择类型" @change="selectApprovalChange">
                        <el-option :label="item.label" :value="item.id" v-for="item in titles"
                                   :key="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="时间" width="250px" prop="approveTime">
                    <el-date-picker
                        v-model="ruleForm.approveTime"
                        align="right"
                        type="date"
                        placeholder="请选择日期"
                        value-format="yyyy-MM-dd"
                        class="el-style">
                    </el-date-picker>
                </el-form-item>

                <el-form-item label="证书照片" prop="photo">
                    <image-uploader
                        class="image-uploader"
                        :value="ruleForm.photo"
                        @input="formatPhotoUrl"
                        :uploadURL="`${$api.fileUploadURL}/prejob`"
                    ></image-uploader>
                </el-form-item>

                <el-form-item label="备注" prop="remark">
                    <el-input type="textarea" v-model="ruleForm.remark"
                              :autosize="{minRows:3,maxRows:5}" style="width: 220px"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" style="text-align: center;margin-bottom: 20px">
                <el-button type="primary" @click="saveApprovalForm()" :loading="ruleLoading">{{$t('c.save')}}</el-button>
            </div>
        </el-dialog>

        <transition enter-active-class="animated zoomInRight"
                    leave-active-class="animated zoomOutUp">
            <router-view @needUpdate="query"></router-view>
        </transition>
    </div>
</template>

<script>
    import api from '@/api';
    import {Debounce, Ticket} from '@/utils';
    import Bus from '@/utils/bus';
    import { ACCEPT_CONFIG } from '@/config/constant';
    import selectMultiple from '@/components/Selectmultiple'
    import selectMultiOrgs from '@/components/SelectMultiOrgs';
    import ImageUploader from "@components/UI/ImageUploaderz";
    import qs from 'qs'

    export default {
        components: {
            selectMultiple,
            selectMultiOrgs,
            ImageUploader
        },

        data(){
            return {
                formSearch:{
                    name:'',
                    account:'',
                    approvalID: [],
                    orgIDs: [],
                    afterData: '',
                    beforeDate: '',
                },
                selectNames: [
                    {
                        key: "preJob",
                    }],
                pagTotal: 0,
                pageSize:20,
                tableData:[],
                currentPage: 1,
                titles: [],
                approvalDialog:false,
                ruleForm: {
                    type: '',
                    approveTime:'',
                    photo: '',
                    remark: '',
                },
                ruleLoading: false,
                ruleRules: {
                    type: [
                        {required: true, message: '请选择开岗放权类型', trigger: 'change'}
                    ],
                    approveTime: [
                        {required: true, message: '请选择日期', trigger: 'change'}
                    ],
                    remark: [
                        {max: 500, message: this.$t('rule.maxLength', ['500']), trigger: 'blur'},
                    ],
                },
                currentUser:'',
                token: '',

                picDialog: false,
            }
        },

        computed: {
            pickerOptions1() {
                let that = this;
                return {
                    disabledDate(time) {
                        if (!that.formSearch.beforeDate) return false;
                        return time.getTime() > new Date(that.formSearch.beforeDate).getTime()
                    },
                }
            },
            pickerOptions2() {
                let that = this;
                return {
                    disabledDate(time) {
                        if (!that.formSearch.afterData) return false;
                        return time.getTime() < new Date(that.formSearch.afterData).getTime()
                    },
                }
            },
            zipGuideUrl() {
                let ticket = Ticket.get().access_token;
                return `${APIURI}api/Download/CertificatePhotoImportGuide?culture=${this.$i18n.locale}&ui-culture=${this.$i18n.locale}&access_token=${ticket}`
            },
            zipSampleUrl() {
                let ticket = Ticket.get().access_token;
                return `${APIURI}api/Download/CertificatePhotoImportSample?culture=${this.$i18n.locale}&ui-culture=${this.$i18n.locale}&access_token=${ticket}`
            }
        },

        mounted() {
            api.getProJobMenu().then(res => {
                res.package.forEach((item,index)=>{
                    this.titles.push({'prop':'approval'+index,'label':item.value,'id':item.id,'minWidth':90})
                })

                // this.query().then(() => {
                //     this.$nextTick(() => {
                //         this.$refs.prejobTable.doLayout()
                //     })
                // })
            })

            this.query()

            Bus.$on('fileAdded', () => {
                this.picDialog = false
            });

            Bus.$on('jobPhotoSuccess', () => {
                this.query();
            });

            // 这个瓜皮Eltable的fixed，数据变化或者页面变化，表格就会错位
            $(window).on('resize.prejob', Debounce(() => {
                this.$nextTick(() => {
                    this.$refs.prejobTable.doLayout()
                })
            }, 300))
        },

        beforeDestroy() {
            // 凡是有全屏显示的页面都需要在销毁前解除对resize的事件绑定
            $(window).off('resize.prejob')
        },

        methods:{
            query(type){
                if(type==1){
                    this.currentPage = 1;
                }
                let queryData ={
                    name:this.formSearch.name,
                    account:this.formSearch.account,
                    orgIDs:this.formSearch.orgIDs,
                    afterData: this.formSearch.afterData,
                    beforeDate: this.formSearch.beforeDate,
                    pageNo: this.currentPage,
                    limit: this.pageSize,
                };
                if (!(this.formSearch.approvalID.includes(0))) {
                    Object.assign(queryData, {
                        approvalID: this.formSearch.approvalID,
                    })
                }

                return api.getPreJobList(queryData).then(res => {
                    let data = res.package;

                    this.token = Ticket.get().access_token

                    this.tableData= data;
                    this.pagTotal = res.total;

                    // this.$nextTick(() => {
                    //     this.$refs.prejobTable.doLayout()
                    // })
                })
            },
            getPreJobVal(data){
                this.formSearch.approvalID = data;
            },
            orgsChange(data) {
                this.formSearch.orgIDs = data;
            },
            editApproval(data){
                this.currentUser=data;
                this.approvalDialog=true;
                this.$refs['ruleForm'] && this.$refs['ruleForm'].resetFields();
                this.ruleForm.approveTime=''
                this.ruleForm.type=''
                this.ruleForm.remark=''
            },
            async deleteApproval(userID, approvalID) {
                await this.$confirm('确定删除该条记录吗？', this.$t('m.tip'), {type: 'warning'})

                let data = {
                    userID,
                    approvalID,
                }

                await this.$api.deletePreJob(data)

                this.$message.success(this.$t('m.delSuccess'))
                return this.query()
            },
            selectApprovalChange(type){
                this.ruleForm.approveTime=''
                this.ruleForm.remark=''
                this.currentUser.approvals.forEach(item=>{
                    if(item.approvalID==type){
                        this.ruleForm.approveTime=item.approveTime
                        this.ruleForm.remark=item.remark
                    }
                })
            },
            saveApprovalForm(){
                this.$refs['ruleForm'].validate((valid) => {
                    if (!valid) return;
                    this.ruleLoading = true;

                    let photo = this.ruleForm.photo
                    if (photo) {
                        photo = photo.split('?access_token')[0]
                    }

                    let data={
                        userID:this.currentUser.userID,
                        approvalID:this.ruleForm.type,
                        approveTime:this.ruleForm.approveTime,
                        remark:this.ruleForm.remark,
                        photo,
                    }

                    api.addPreJob(data).then(res => {
                        this.ruleLoading = false;
                        this.approvalDialog = false;
                        this.currentUser='';
                        this.success(this.$t('m.editSuccess'));
                        this.query();
                    }).catch(error => this.ruleLoading = false)

                })
            },

            formatPhotoUrl(url) {
                if (!url) {
                    return this.ruleForm.photo = ''
                }

                let token = Ticket.get().access_token
                this.ruleForm.photo = `${url}?access_token=${token}`
            },

            //开岗放权导入
            importPreJob(e){
                let file = e.target.files[0];
                let formData = new FormData();      //创建form对象
                formData.append('file', file);
                api.importPreJob(formData).then(res => {
                    this.$message.success(res.message)
                    e.target.value = '';
                    this.query();
                }).catch(() => {
                    // 出错时清空文件，不然无法触发change
                    e.target.value = '';
                })
            },

            // 导入照片
            certUploadByPic() {
                Bus.$emit('openUploader', {
                    options: {
                        target: this.$api.zipUploaderURL,
                        testChunks: true,
                        mergeFn: this.$api.mergeZipUpload,
                        accept: ACCEPT_CONFIG.zip
                    },
                    params: {
                        businessType: 'PreJobPhoto'
                    }
                })
            },

            //模板下载
            downloadTemplate(){
                let culture = this.$i18n.locale;
                const ticket = Ticket.get().access_token;

                let url = APIURI + `api/Download/PreJobApprovalTemplate?culture=${culture}&ui-culture=${culture}&access_token=${ticket}`
                this.download(url)
            },

            //开岗放权导出
            exportPreJob(formName) {
                const token = Ticket.get().access_token;
                const culture = this.$i18n.locale;

                let queryData = {
                    name:this.formSearch.name,
                    account:this.formSearch.account,
                    orgIDs:this.formSearch.orgIDs,
                    approvalID:this.formSearch.approvalID,
                    afterData: this.formSearch.afterData,
                    beforeDate: this.formSearch.beforeDate,
                    access_token: token,
                    culture: culture,
                    'ui-culture': culture
                }

                if (queryData.approvalID.includes(0)) {
                    delete queryData.approvalID;
                }

                let queryString = qs.stringify(queryData, {indices: false})

                let url = `${APIURI}/api/Export/Excel/PrejobApproval?${queryString}`

                this.download(url)
            },

            download(url) {
                let downloadLink = document.createElement('a')
                downloadLink.href = url
                downloadLink.download = ''
                // 触发点击事件执行下载
                downloadLink.click()
            },

            handleCurrentChange(val) {
                this.currentPage = val;
                this.query();
            },
            handleSizeChange(val) {
                this.pageSize = val;
                this.query();
            },
            success(msg) {
                this.$message({
                    message: msg,
                    type: 'success'
                })
            },
        },
    }
</script>

<style scoped lang="scss">
    @import '../../style/const.scss';

    .button-group .btn,
    .dropdown-menu .btn {
        display: block;
        cursor: pointer;
        input {
            display: none;
        }
    }

    .button-group {
        > button {
            margin-left: -2px;
            border-left: none;
        }
    }

    .form-table {
        /deep/ td {
            padding: 10px 0!important;
            &:hover {
                .remove-wrap {
                    display: block;
                }
            }
        }
    }

    .approval-cell {
        .photo {
            padding-top: 2px;
            padding-bottom: 4px;
            width: 130px;
            height: 90px;
            cursor: pointer;
            object-fit: contain;
            transition: all .3s;
            &:hover {
                filter: brightness(1.1);
            }
        }

        .date {
            position: relative;
            font-size: 12px;
            color: #666;
        }

        .remove-wrap {
            position: absolute;
            top: 2px;
            right: 4px;
            padding: 2px 6px;
            cursor: pointer;
            display: none;
            transition: all .3s;
            .nucfont {
                color: #a3a4a9;
            }
            &:hover .nucfont{
                color: $red;
            }
        }
    }

    .pic-dialog {
        .explain-text {
            line-height: 1.6;
            > p {
                color: #666;
                margin-bottom: 5px;
            }
            .sample {
                color: #1c42ff;
                text-decoration: underline;
                &:hover {
                    color: lighten(#1c42ff, 10%);
                }
            }
        }
    }

    .image-uploader {
        /deep/ .el-upload--picture-card {
            width: 240px;
        }
    }
</style>


